import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

function TermsAndConditions() {
    return (
        <Container className="py-4">
            <Row className="justify-content-center">
                <Col lg={10} md={12}>
                    <Card className="shadow-sm">
                        <Card.Header className="bg-primary text-white">
                            <h2 className="mb-0">
                                <i className="fas fa-file-contract me-2"></i>
                                Terms and Conditions
                            </h2>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <div className="terms-content">
                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">1. Acceptance of Terms</h3>
                                    <p>
                                        By accessing and using BodyIntel AI Assistant ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                                    </p>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">2. Description of Service</h3>
                                    <p>
                                        BodyIntel AI Assistant is an artificial intelligence-powered tool that provides health, fitness, and wellness information based on PubMed data. The Service is designed to offer educational and informational content only.
                                    </p>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">3. Privacy Policy</h3>

                                    <h4 className="text-secondary mb-2">3.1 Information Collection</h4>
                                    <p>
                                        We may collect information that you provide directly to us, including but not limited to:
                                    </p>
                                    <ul>
                                        <li>Questions and queries you submit to the Service</li>
                                        <li>Usage data and interaction patterns</li>
                                        <li>Technical information such as IP address, browser type, and device information</li>
                                    </ul>

                                    <h4 className="text-secondary mb-2">3.2 Use of Information</h4>
                                    <p>
                                        We use the collected information to:
                                    </p>
                                    <ul>
                                        <li>Provide and improve the Service</li>
                                        <li>Process your questions and generate responses</li>
                                        <li>Analyze usage patterns to enhance user experience</li>
                                        <li>Ensure the security and integrity of the Service</li>
                                    </ul>

                                    <h4 className="text-secondary mb-2">3.3 Data Protection</h4>
                                    <p>
                                        We implement appropriate security measures to protect your information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
                                    </p>

                                    <h4 className="text-secondary mb-2">3.4 Third-Party Services</h4>
                                    <p>
                                        Our Service may integrate with third-party services and APIs. These services have their own privacy policies, and we are not responsible for their practices.
                                    </p>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">4. No Warranty Disclaimer</h3>

                                    <h4 className="text-secondary mb-2">4.1 Service Availability</h4>
                                    <p>
                                        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE.
                                    </p>

                                    <h4 className="text-secondary mb-2">4.2 Medical Information Disclaimer</h4>
                                    <p>
                                        <strong>IMPORTANT:</strong> The information provided by BodyIntel AI Assistant is for educational and informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment.
                                    </p>
                                    <ul>
                                        <li>Always seek the advice of qualified healthcare providers</li>
                                        <li>Never disregard professional medical advice or delay seeking it</li>
                                        <li>Information may not be complete, accurate, or up-to-date</li>
                                        <li>Individual health conditions may vary significantly</li>
                                    </ul>

                                    <h4 className="text-secondary mb-2">4.3 Accuracy of Information</h4>
                                    <p>
                                        While we strive to provide accurate information based on PubMed data, we cannot guarantee the accuracy, completeness, or timeliness of any information provided. The Service may contain errors, inaccuracies, or outdated information.
                                    </p>

                                    <h4 className="text-secondary mb-2">4.4 Limitation of Liability</h4>
                                    <p>
                                        IN NO EVENT SHALL BODYINTEL AI, ITS AFFILIATES, OR THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR RELATING TO YOUR USE OF THE SERVICE.
                                    </p>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">5. User Responsibilities</h3>
                                    <p>
                                        You agree to:
                                    </p>
                                    <ul>
                                        <li>Use the Service only for lawful purposes</li>
                                        <li>Not attempt to gain unauthorized access to the Service</li>
                                        <li>Not interfere with or disrupt the Service</li>
                                        <li>Not use the Service to transmit harmful or malicious content</li>
                                        <li>Consult healthcare professionals for medical decisions</li>
                                    </ul>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">6. Intellectual Property</h3>
                                    <p>
                                        The Service and its original content, features, and functionality are owned by BodyIntel AI and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                                    </p>
                                </section>

                                <section className="mb-4">
                                    <h3 className="text-primary mb-3">7. Modifications to Terms</h3>
                                    <p>
                                        We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the new terms on this page. Your continued use of the Service after such modifications constitutes acceptance of the updated terms.
                                    </p>
                                </section>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default TermsAndConditions;
